import axios from 'axios'
const BASE_API_URL = process.env.REACT_APP_API_URL
//=====================Item URL======================
export const GET_ALL_NEW_MODEL_REQUEST_LIST = `${BASE_API_URL}/NewModelRequest/NewModelRequest_GetList` //Get List
export const CREATE_NEW_MODEL_REQUEST = `${BASE_API_URL}/NewModelRequest/NewModelRequest_AddDetails` //Add
export const UPDATE_NEW_MODEL_REQUEST = `${BASE_API_URL}/NewModelRequest/NewModelRequest_UpdateDetails` //Update
export const UPDATE_NEW_MODEL_REQUEST_BY_NEW_MODEL_REQUEST_ID = `${BASE_API_URL}/NewModelRequest/NewModelRequest_GetBy_NewModelRequestID` //Grt By Id
export const DELETE_NEW_MODEL_REQUEST = `${BASE_API_URL}/NewModelRequest/NewModelRequest_Delete_Details` //Delete
export const UPDATE_NEW_MODEL_REQUEST_STATUS = `${BASE_API_URL}/NewModelRequest/NewModelRequest_Updates_Status` //Update Status

// ============================================================================
export function GetNewModelRequestListAPI() {
  return axios.get(GET_ALL_NEW_MODEL_REQUEST_LIST)
}

// ============================================================================
export function CreateNewModelRequestAPI(
  vehicleMakeID: number,
  customerID: number,
  statusID: number,
  vehicleModelName: string,
  noOfSeat: number
) {
  return axios.post(CREATE_NEW_MODEL_REQUEST, {
    vehicleMakeID,
    customerID,
    statusID,
    vehicleModelName,
    noOfSeat,
  })
}

// ============================================================================
export function UpdateNewModelRequestAPI(
  NewModelRequestID: number,
  vehicleMakeID: number,
  customerID: number,
  statusID: number,
  vehicleModelName: string,
  noOfSeat: number
) {
  return axios.post(UPDATE_NEW_MODEL_REQUEST, {
    NewModelRequestID,
    vehicleMakeID,
    customerID,
    statusID,
    vehicleModelName,
    noOfSeat,
  })
}

// ============================================================================
export function GetNewModelRequestByNewModelRequestIDAPI(NewModelRequestID: number) {
  return axios.post(UPDATE_NEW_MODEL_REQUEST_BY_NEW_MODEL_REQUEST_ID, {NewModelRequestID})
}

// ============================================================================
export function DeleteNewModelRequestAPI(NewModelRequestID: number) {
  return axios.post(DELETE_NEW_MODEL_REQUEST, {NewModelRequestID})
}
// ============================================================================
export function UpdateNewModelRequestStatusAPI(NewModelRequestID: number, statusID: number) {
  return axios.post(UPDATE_NEW_MODEL_REQUEST_STATUS, {NewModelRequestID, statusID})
}
